<header class="header">
    <div class="container-logo">
        <div class="logo"><img
                src="{{ showIcon === 1 ? './assets/temporals/Logo_Akana_Azul.png' : './assets/logos/Logo_SCF_red.png' }}"
                [ngStyle]="{'cursor':  showIcon === 1 ? 'pointer' : 'auto', 'width': showIcon !== 1 ? '130px' : '95px', 'padding': showIcon !== 1 ? '0 ' : '0'}"
                (click)="goToHome(showIcon === 1)" alt=""></div>
    </div>
    <div class="language-selector-container">
        <app-language-selector></app-language-selector>
    </div>
</header>